export const sectionCaptionDisplayed = (section) => (
  section?.display !== false && section?.displayCaption !== false
);
